<template>
	<div class="card">
		<div class="card-header">Transakcie</div>
		<div class="card-body pt-3 px-0">
            <Loading v-if="loading" class="mt-2 mb-1" />
			<data-grid :items="items" :columns="columns" :on-detail-open="loadDetail" v-else>
				<div class="text-left text-md-right" slot="transactionPrice" slot-scope="{ item }">
					<price :value="item.transactionPrice" />
				</div>
				<template slot="date" slot-scope="{ item }">
					{{ item.date | date }}
				</template>
				<template slot="detail" slot-scope="{ item }">
                    <Loading v-if="!item.detail" class="mb-5 p-5"/>
					<div class="pb-3" v-if="item.detail">
						<strong>Podrobnosti</strong>
						<div class="details-wrapper">
							<div class="row" v-if="item.detail.bankAccount">
								<div class="col-md-4">Účet Sympatie:</div>
								<div class="col-md-8">{{item.detail.bankAccount}}</div>
							</div>
                            <div class="row" v-if="item.detail.clientBankAccount">
                                <div class="col-md-4">Účet klienta:</div>
                                <div class="col-md-8">{{item.detail.clientBankAccount}}</div>
                            </div>
                            <div class="row" v-if="item.detail.startDate">
                                <div class="col-md-4">Dátum založenia TV:</div>
                                <div class="col-md-8">{{item.detail.startDate | date}}</div>
                            </div>
                            <div class="row" v-if="item.detail.endDate">
                                <div class="col-md-4">Dátum ukončenia TV:</div>
                                <div class="col-md-8">{{item.detail.endDate | date}}</div>
                            </div>
                            <div class="row" v-if="item.detail.rate">
                                <div class="col-md-4">Úroková sadzba TV:</div>
                                <div class="col-md-8">{{item.detail.rate | number}} %</div>
                            </div>
                            <div class="row" v-if="item.detail.expRateNetto">
                                <div class="col-md-4">Úrok netto:</div>
                                <div class="col-md-8">{{item.detail.expRateNetto | number}} {{ item.currency }}</div>
                            </div>
                            <div class="row" v-if="item.detail.pl">
                                <div class="col-md-4">Zisk/strata:</div>
                                <div class="col-md-8">{{item.detail.pl | number}}</div>
                            </div>
                            <div class="row" v-if="item.detail.plEur">
                                <div class="col-md-4">Zisk/strata v EUR:</div>
                                <div class="col-md-8">{{item.detail.plEur | number}}</div>
                            </div>
                            <div class="row" v-if="item.detail.plPerc">
                                <div class="col-md-4">Zisk/strata (%):</div>
                                <div class="col-md-8">{{item.detail.plPerc | number}} %</div>
                            </div>
                            <div class="row" v-if="item.detail.plPercEur">
                                <div class="col-md-4">Zisk/strata v EUR (%):</div>
                                <div class="col-md-8">{{item.detail.plPercEur | number}} %</div>
                            </div>
                            <div class="row" v-if="item.detail.dvd">
                                <div v-if="item.eqid === 'Bonds'" class="col-md-4">Suma kupónov:</div>
                                <div v-else class="col-md-4">Suma dividend:</div>
                                <div class="col-md-8">{{item.detail.dvd  | number}}</div>
                            </div>
                            <div class="row" v-if="item.detail.dvdEur">
                                <div v-if="item.eqid === 'Bonds'" class="col-md-4">Suma kupónov (EUR):</div>
                                <div v-else class="col-md-4">Suma dividend (EUR):</div>
                                <div class="col-md-8">{{item.detail.dvdEur | number}}</div>
                            </div>
                            <div class="row" v-if="item.detail.couponDate">
                                <div class="col-md-4">Nasledujúci kupón:</div>
                                <div class="col-md-8">{{item.detail.couponDate | date}}</div>
                            </div>
                            <div class="row" v-if="item.detail.volume">
                                <div class="col-md-4">Počet:</div>
                                <div class="col-md-8">{{item.detail.volume}}</div>
                            </div>
                            <div class="row" v-if="item.detail.price">
                                <div class="col-md-4">Cena:</div>
                                <div class="col-md-8">{{item.detail.price | number}}</div>
                            </div>
                            <div class="row" v-if="item.detail.settlementDate">
                                <div class="col-md-4">Dátum vysporiadania:</div>
                                <div class="col-md-8">{{item.detail.settlementDate | date}}</div>
                            </div>
                            <div class="row" v-if="item.detail.avgPrice">
                                <div class="col-md-4">Vstupná cena:</div>
                                <div class="col-md-8">{{item.detail.avgPrice}}</div>
                            </div>
                            <div class="row" v-if="item.detail.auv">
                                <div class="col-md-4">AÚV:</div>
                                <div class="col-md-8">{{item.detail.auv | number}}</div>
                            </div>
                            <div class="row" v-if="item.detail.thirdPartyFee">
                                <div class="col-md-4">Poplatok tretích strán::</div>
                                <div class="col-md-8">{{item.detail.thirdPartyFee}}</div>
                            </div>
						</div>
					</div>
				</template>
			</data-grid>
            <Loading v-if="!loading && loadingNext" class="mt-2 mb-1" />
			<div class="mt-4 text-center" v-if="!loading">
				<button type="button" class="btn btn-primary" @click="nextPage()">
					<span>Načítať ďalšie</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import DataGrid from "../../../components/DataGrid";
import Loading from "../../../components/Loading";
import Price from "../../../components/price";
import transactions from "@/store/modules/transactions";

export default {
	name: "List",
	components: {
		Price,
		Loading,
		DataGrid,
	},
	props: {
		portfolio: {
			type: String | null,
			required: false,
			default: null,
		},
	},
	watch: {
		portfolio() {
			this.$store.commit("transactions/resetTransactions");
			this.page = 1;
			this.loadData();
		},
		from() {
			this.page = 1;
			this.loadData();
		},
		to() {
			this.page = 1;
			this.loadData();
		},
		currentFilter() {
            this.$store.commit("transactions/resetTransactions");
            this.page = 1;
			this.loadData();
		},
	},
	computed: {
		items() {
			return this.$store.state.transactions.transactions;
		},
		loading() {
			return this.$store.state.transactions.loadingList;
		},
		loadingNext() {
			return this.$store.state.transactions.loadingNext;
		},
		from() {
			return this.$store.state.transactions.from;
		},
		to() {
			return this.$store.state.transactions.to;
		},
		currentFilter() {
			return this.$store.state.transactions.transactionsTypeFilter;
		},
	},
	mounted() {
		this.$store.commit("transactions/resetTransactions");
		this.loadData();
	},
	methods: {
		loadData() {
            this.$store.commit("transactions/resetTransactionDetails");
			this.$store.dispatch("transactions/transactions", {
				page: this.page,
				append: this.append,
				portfolioId: this.portfolio,
				from: this.from,
				to: this.to,
				filter: this.currentFilter == '' ? null : this.currentFilter,
			});
		},
        loadDetail(transaction, index) {
            this.$store.dispatch("transactions/transactionDetail", {
                order: transaction.order,
                dealId: transaction.dealId,
                date: transaction.date,
                index
            });
        },
		nextPage() {
			this.page += 1;
            this.append = true;
			this.loadData();
            this.append = false;
		},
	},
	data() {
		return {
			page: 1,
            append: false,
			columns: [
				{
					name: "Dátum transakcie",
					slug: "date",
				},
				{
					name: "Portfólio",
					slug: "contactNumber",
				},
				{
					name: "Suma",
					slug: "transactionPrice",
					thClass: "text-right",
				},
				{
					name: "Mena",
					slug: "currency",
				},
				{
					name: "Popis",
					slug: "description",
				},
				{
					name: "Poznámka",
					slug: "note",
				},
			],
		};
	},
};
</script>

<style scoped></style>
